import { render, staticRenderFns } from "./LatestDocumentNews.vue?vue&type=template&id=51ceaafe&scoped=true&"
import script from "./LatestDocumentNews.vue?vue&type=script&lang=js&"
export * from "./LatestDocumentNews.vue?vue&type=script&lang=js&"
import style0 from "./LatestDocumentNews.vue?vue&type=style&index=0&id=51ceaafe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ceaafe",
  null
  
)

export default component.exports